import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { CustomCommonModulesModule } from "app/custom-common-modules/custom-common-modules.module";

import { ChartsModule } from 'ng2-charts';
import { MatTableModule } from "@angular/material/table";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from "@angular/material/core"
import { MatSelectModule } from '@angular/material/select';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatTooltipModule} from '@angular/material/tooltip';

import { SharedModule } from "app/shared/shared.module";
import { PipeModule } from "app/shared/pipes/pipe.module";
import { createTranslateLoader } from 'app/app.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { AssetComponent } from './asset.component';
import { AssetRoutingModule } from './asset-routing.module';
import { SellModalComponent } from './sell-modal/sell-modal.component';
import { BuyModalComponent } from './buy-modal/buy-modal.component';

@NgModule({
  declarations: [
    AssetComponent,
    SellModalComponent,
    BuyModalComponent,
  ],
  imports: [
    ChartsModule,
    AssetRoutingModule,
    CommonModule,
    NgxChartsModule,
    CustomCommonModulesModule,
    ReactiveFormsModule,
    MatTableModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatGridListModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    PipeModule,
    SharedModule,
    MatTooltipModule
  ],
})
export class AssetModule {}
